export class ApiResponse {

    success: boolean;

    response: any;

    constructor(success: boolean, response: any) {
        this.success = success;
        this.response = response;
    }

    getErrorMessage(fieldName: string): string | null {
        if (this.response.errorMessage && this.response.errorMessage[fieldName]) {
            let firstKey = Object.keys(this.response.errorMessage[fieldName])[0];
            return this.response.errorMessage[fieldName][firstKey];
        }
        return '';

    }

}

/**
 * check are there errorMessages in the response.
 * @param reason
 */
export function getErrorMessagesFromResponse(reason: any) {
    return (reason && reason.response && reason.response.data && reason.response.data.error) ? reason.response.data.error : null;
}

/**
 * get message text.
 * @param errorMessage
 */
export function getMessageText(errorMessage: any) {
    let message = '';
    // error message can be more for the same inputFieldState
    if (typeof errorMessage === 'object') {
        for (let key in errorMessage) {
            if (typeof errorMessage[key] === 'object') {
                message += getMessageText(errorMessage[key]);
            } else {
                message += errorMessage[key] ? (errorMessage[key] + '\n') : '';
            }
        }
    } else if (errorMessage) {
        message = errorMessage;
    }
    return message;
}
